import React, { useRef } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

import WhiteTrashIcon from '../../../../image/WhiteTrashIcon.png';
import WhitePencelIcon from '../../../../image/WhitePencelIcon.png';

export default function RefundInfoView(props) {
  const {
    data,
    mode = 'refund',
    counterMemberName,
    onClickHoldingAndExtendButton,
    onClickHoldingEdit,
    onClickDeleteHoldingHistory,
    onClickModifyRefund,
    onClickDeleteRefund
  } = props;

  const isTransferOut = mode === 'transferOut';

  const { t } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const ComponentRef = useRef();
  const ModifyRef = useRef();
  const DeleteRef = useRef();

  // 이행 일수 계산 후 표출 //
  function decidePriceView() {
    if (data.refundCardPrice === 0) return data.refundCashPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCash');
    else if (data.refundCashPrice === 0) return data.refundCardPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCard');
    else return (data.refundCardPrice + data.refundCashPrice).toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
  }

  // 컴포넌트 마우스 호버링 //
  function onMouseOver() {
    if (isTransferOut) return;
    ModifyRef.current.style.opacity = 1;
    DeleteRef.current.style.opacity = 1;
  }

  // 컴포넌트 마우스 호버링 //
  function onMouseLeave() {
    if (isTransferOut) return;
    ModifyRef.current.style.opacity = 0;
    DeleteRef.current.style.opacity = 0;
  }

  // 컴포넌트 클릭시 //
  function onClickComponent(e) {
    if (isTransferOut) return;
    if (ModifyRef.current.contains(e.target) || DeleteRef.current.contains(e.target)) return;

  }

  // 수정버튼 클릭시 //
  function onClickModify() {
    onClickModifyRefund();
  }

  // 삭제버튼 클릭시 //
  function onClickDelete() {
    onClickDeleteRefund(data);
  }

  return (
    <TopLevelWrapper>
      <ComponentBox
        ref={ComponentRef}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
        onClick={onClickComponent}>
        <TotalTextWrapper>
          {
            isTransferOut ?
              <RowGroup>
                <TextWrapper>
                  <EllipsisText color={theme.white}>{t('memberDetail.transferCompletedToName').replace('{name}', counterMemberName || t('memberDetail.transferCounterDeletedMember'))}</EllipsisText>
                </TextWrapper>
                <TextWrapper width={65}>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.white} cursor='pointer'>{data.transferDate ? moment(data.transferDate).format(t('calendarInput.shortDateFormat')) : ''}</Text>
                </TextWrapper>
              </RowGroup>
              :
              <RowGroup>
                <TextWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.white} cursor='pointer'>{t('memberDetail.refundStatusComplete')}</Text>
                </TextWrapper>
                <TextWrapper width={65}>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.white} cursor='pointer'>{moment(data.refundApprovalDate).format(t('calendarInput.shortDateFormat'))}</Text>
                </TextWrapper>
                <TextWrapper width={148}>
                  {(() => {
                    const result = decidePriceView();
                    const dashIdx = result.indexOf('  - ');
                    if (dashIdx === -1) return <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.white} cursor='pointer'>{result}</Text>;
                    return (
                      <PriceRow>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.white} cursor='pointer' style={{ flexShrink: 0 }}>{result.slice(0, dashIdx)}</Text>
                        <PaymentMethodText color={theme.white}>{result.slice(dashIdx)}</PaymentMethodText>
                      </PriceRow>
                    );
                  })()}
                </TextWrapper>
                <TextWrapper width={403}>
                  <EllipsisText color={theme.white}>{data.reason}</EllipsisText>
                </TextWrapper>
                <TotalIconWrapper>
                  <IconWrapper ref={ModifyRef} onClick={onClickModify}>
                    <Icon src={WhitePencelIcon}/>
                  </IconWrapper>
                  <IconWrapper ref={DeleteRef} onClick={onClickDelete}>
                    <Icon src={WhiteTrashIcon}/>
                  </IconWrapper>
                </TotalIconWrapper>
              </RowGroup>
          }
        </TotalTextWrapper>
      </ComponentBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  width: 100%;
`;

const ComponentBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: -35px;

  width: 836px;
  height: 87px;
  
  border-radius: 0px 10px 12px 12px;
  background-color: ${props => props.theme.pointRedAlpha50};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TotalTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-left: 20px;
  margin-top: 50px;

  gap: 10px;
`;

const RowGroup = styled.div`
  display: contents;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-right: 8px;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const TotalIconWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 12px;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;

  opacity: 0;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const Icon = styled.img`
  width: 100%;
  height: 100%;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;

const PriceRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 0;
  overflow: hidden;
`;

const PaymentMethodText = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const EllipsisText = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;